<leerplus-game
  class="size-full"
  map="di_canvasmap_AL6QsFdcC_7dZq3FxE7Wz"
  [mission]="mission()"
  [config]="{
    id: 'CODE-leercabine',
    saveManager: saveManager(),
    studio: {
      packageProvider: studioDataPackageProvider(),

      source: {
        url: 'https://cas.woordkr8.dev.gametailors.com/',
        project: 'p_kcGxFNoKRtJ7L7H6mMp0I',
      },
    },

    debug: {
      panel: true,
      skips: true,
    },

    extensions: [extension],
  }"
  (missionCompleted)="missionCompleted.emit($event.uid)"
/>
